import {MarketStatsInitializer} from "../../../../common/ts/components/core/market-stats/MarketStatsInitializer";
import {MarketStatsStyles} from "../../../../common/ts/components/charts/MarketStatsChart";
import {isMobileDevice} from "../../device";

function generateStyles(isMobile: boolean): MarketStatsStyles {
    return {
        lineColor: '#552D73',
        fillColor: '#FF50500D',
        pointColor: '#FFFFFF',
        pointHoverColor: '#552D73',
        axisBorderColor: '#E0E0E0',
        scalesLabelColor: isMobile ? '#4A4A4A' : '#7F7F7F',
        pointRadius: isMobile ? 5 : 8,
        tickPadding: isMobile ? 0 : 10,
        tooltipTitleFontSize: isMobile ? 10 : 14,
        tooltipBodyFontSize: isMobile ? 12 : 16,
        chartType: 'line',
        xAxisRotation: isMobile ? 90 : false,
        yAxisRotation: false,
        barThickness: undefined,
        barBorderRadius: undefined,
    }
}

window.onload = () => {
    new MarketStatsInitializer((device: string) => {
        return generateStyles(isMobileDevice(device))
    }).init();
}
